module.exports = __webpack_public_path__ + "img/graph-growing.5ef5f91f.jpg";